import React, { useEffect, useState, useContext } from "react";
import axios from 'axios';
import DataSnapshots from "components/Private/BaolinEventsAnalytics/ChingMing/DataSnapshots";
import ChartsContext from "../../contexts/ChartsContext";

// react-bootstrap components
import {
    Container,
} from "react-bootstrap";
import InsightCharts from "components/Private/BaolinEventsAnalytics/ChingMing/InsightCharts";

function ChingMingDashboard() {
    const { setChartsData, setUpdateTime } = useContext(ChartsContext);
    const fetchEventStatistics = () => {
        // For Ching Ming, we use 'vegefest' or 'chingming' as event param if needed, 
        // but the router is at /chingming
        // The previous logic for other events often used ?event=vegefest
        axios.get(`${process.env.REACT_APP_SERVER_URL}/chingming/geteventstatistics?event=chingming`)
            .then(response => {
                const currentTime = new Date().toLocaleString();
                setUpdateTime(currentTime);
                console.log("Ching Ming API Response Data:", response.data);

                // Map response data to context if needed, but if keys match, just set it.
                // Expected keys: totalEntries, totalToday, checkIns, registrationPerDay, etc.
                setChartsData(response.data);
            })
            .catch(error => {
                console.error("Error fetching event statistics:", error);
            });
    };

    useEffect(() => {
        fetchEventStatistics(); // Initial data fetch
    }, []);

    return (
        <>
            <Container fluid>
                <DataSnapshots onRefresh={fetchEventStatistics} />
                <InsightCharts onRefresh={fetchEventStatistics} />
            </Container>
        </>

    );
}

export default ChingMingDashboard;
